// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"392c36a1","453":"6a4acbca"}[chunkId] + ".chunk.js";
};